// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
::after,
::before {
  box-sizing: border-box;
}

body {
  font-family: 'Montserrat', Arial, Helvetica, sans-serif;
  color: '#000';
}

.card {
  /* max-height: 450px; 
  overflow: auto;*/
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff !important;
  background-clip: border-box;
  border: 1px solid #c8ced3;
  margin-bottom: 0rem;
  box-shadow: 0 1px 4px 0 #545a61ed;
}
.chart-card {
  min-height: 450px;
  max-height: 450px;
}

@media only screen and (max-width: 760px) {
  .chart-card {
    min-height: 530px;
    max-height: 530px;
    margin-bottom: 1rem;
  }
}

.card-body {
  flex: 1 1 auto;
  padding: 0.5rem;
}

.card .card-title {
  position: relative;
  color: black;
  font-size: 18px !important;
}

.card,
.floating-labels select.form-control > option {
  background: #ffffff;
  border-radius: 7px !important;
}

.card,
.floating-labels select.form-control > option {
  background: var(--foreground-secondary);
  border-radius: 7px !important;
}

@media (min-width: 321px) and (max-width: 575.98px) {
  .card-body .form-group {
    margin: 0;
  }
}

.h4,
h4 {
  font-size: 1.3125rem;
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .section h4.card-title {
    font-size: 18px;
  }
}

@media (min-width: 768px) {
  .col-md-7 {
    flex: 0 0 58.33333333%;
    max-width: 96.333333%;
  }
}

@media (min-width: 576px) {
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
}

@media (min-width: 321px) and (max-width: 575.98px) {
  .section .row {
    margin-bottom: 20px;
  }
}

@media (min-width: 992px) {
  .performance .col-xl-6 :nth-child(odd) {
    padding-right: 0.65em;
  }
}

@media (min-width: 1200px) {
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (min-width: 768px) {
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

@media (min-width: 992px) {
  .hide-widget {
    position: absolute;
    right: 4%;
    bottom: 2%;
    z-index: 1;
  }
}

.row.section div {
  cursor: grab;
}

/* Header Icons CSS starts here */

/* @media (min-width: 601px) { */
.calenderIcons {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid rgb(4, 84, 170);
  color: rgb(4, 84, 170);
  width: 35px;
  border-radius: 20px;
  height: 35px;
  margin-top: -8px !important;
}
/* } */

.calenderIcons:hover {
  color: #fff !important;
  background: #36f !important;
  border: 1px solid rgb(17, 42, 119) !important;
}

.calenderIcons:focus {
  color: #fff !important;
  background: #36f !important;
  border: 1px solid rgb(17, 42, 119) !important;
}

.calenderIConCLicked {
  cursor: pointer;
  position: relative;
  width: auto;
}

@media (min-width: 992px) {
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
}

@media (max-width: 600px) {
  .calenderIcons {
    border: 1px solid rgb(4, 84, 170);
    color: rgb(4, 84, 170);
    width: auto;
  }
  .card .card-title {
    position: relative;
    color: black;
    font-size: 16px !important;
  }
}

.button {
  margin: 4px 2px;
}

/* Header Icons CSS ends here  */

/* Dialog popup css starts here */

.form-container {
  /* max-width: auto; */
  width: min-content;
  padding: 10px;
  background-color: white;
}

.form-popup {
  display: none;
  position: absolute;
  top: 8%;
  right: 6%;
  border: 3px solid #f1f1f1;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 9;
}

.form-popup1 {
  display: none;
  position: absolute;
  margin: 15px;
  top: 5%;
  right: 6%;
  border: 3px solid #f1f1f1;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 9;
}
/* Dialog popup css ends here */

/* Production Performance button list css starts here */

@media (min-width: 576px) and (max-width: 767.98px) {
  .floating-labels .row {
    margin-left: -2px;
    /* margin-right: -15px; */
  }
}

@media (min-width: 601px) {
  .floating-labels select.form-control > option {
    font-size: 14px;
    bottom: 25px !important;
  }
}

.floating-labels select.form-control > option {
  font-size: 14px;
}

.floating-labels .row {
  margin-top: 10px;
  margin-left: -15px;
  margin-right: -15px;
}
.floating-labels select option {
  width: 20em;
}

.floating-labels .form-group {
  position: relative;
  margin-right: -18px;
}

.performance {
  z-index: 0;
}
@media (min-width: 1200px) {
  .performance .card-body .form-group {
    margin: 0;
  }

  .performance .card-body .form-group .form-control {
    font-size: 14px;
    padding: 0;
    width: 85px;
    margin: -11px 7px 0;
  }
}
.floating-labels .form-control {
  padding: 8px 10px 10px;
  display: block;
  border: none;
  border-radius: 0;
  border-bottom: 1.5px solid #707070;
}

.form-group {
  margin-bottom: 1.25rem !important;
}

@media (min-width: 321px) and (max-width: 575.98px) {
  .floating-labels select {
    background-position-x: 96%;
    background-position-y: 46%;
    font-size: 10px;
    margin-right: -5px !important;
  }
  .floating-labels .form-group {
    position: relative;
    margin-right: -32px;
  }
  .textLabel {
    font-size: 8px;
  }
}

.section .container {
  max-width: 25%;
}

/* .section .active::after {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 13px solid #2f353a;
  content: '';
  position: absolute;
  right: 0;
  left: 0;
  top: initial;
  bottom: -13px;
  margin: 0 auto;
} */

.section button {
  border-color: #eaeaea;
  border-width: 1px;
}

.section button {
  border-color: var(--graph-btn-border);
  color: black;
}

.section .btn-outline-dark {
  border-radius: 6px;
  font-family: 'Montserrat', Arial, Helvetica, sans-serif;
  font-weight: 500;
  font-size: 14px;
  border: 2px solid #2f353a;
  color: #2f353a;
  background-color: #ffffff;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.section .btn-outline-dark:hover {
  color: #fff;
  background-color: #2f353a;
  border-color: #2f353a;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.btn-outline-dark:not(:disabled):not(.disabled).active,
.btn-outline-dark:not(:disabled):not(.disabled):active,
.show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #2f353a;
  border-color: #2f353a;
  box-shadow: inset 0 0 0 1px #1e2226;
}

.button {
  margin: 4px 2px;
}

@media (min-width: 768px) {
  .col-md-3 {
    flex: 0 0 35%;
    max-width: 40%;
  }
}

/* Production Performance button list css ends here */

/* Dashboard Balance CSS starts here */

.dashboardAmount,
.empty-data {
  background: var(--foreground-secondary);
  border-radius: 7px !important;
  box-shadow: 0 1px 4px 0 #545a61ed;
}

.dashboardAmount .amountList {
  margin: 10px auto;
  width: 95%;
  position: relative;
  padding: 10px 20px;
}

@media (min-width: 1200px) {
  .dashboardAmount .amountList > div:first-child {
    padding-left: 0;
  }

  .dashboardAmount .amountList > div {
    padding: 10px 15px;
    flex: 0 0 20%;
    max-width: 20%;
  }

  .dashboardAmount .rightIcon img {
    position: absolute;
    top: 0;
    right: 0;
    width: 45px;
    height: 45px;
    margin-top: 0;
  }

  .dashboardAmount .amountList > div:nth-child(1)::after,
  .dashboardAmount .amountList > div:nth-child(2)::after,
  .dashboardAmount .amountList > div:nth-child(3)::after,
  .dashboardAmount .amountList > div:nth-child(4)::after {
    width: 2px;
    content: '';
    top: 3px;
    right: 0;
    bottom: 0;
    position: absolute;
    margin: 0 auto;
    background-color: #d8d8d8;
  }
}

@media (min-width: 321px) and (max-width: 575.98px) {
  .dashboardAmount .amountList {
    padding: 0 !important;
  }

  .dashboardAmount .amountList > div {
    padding: 20px;
    flex: 0 0 90%;
    max-width: 90%;
    margin: 0 auto;
  }

  .dashboardAmount .rightIcon img {
    position: absolute;
    bottom: 14px;
    right: 0;
    width: 45px;
    height: 45px;
    margin-top: 20px;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .dashboardAmount .amountList {
    padding: 0 !important;
  }

  .dashboardAmount .amountList > div {
    padding: 10px;
    flex: 0 0 33%;
    max-width: 33%;
  }

  .dashboardAmount .amountList > div:nth-child(1)::after,
  .dashboardAmount .amountList > div:nth-child(2)::after,
  .dashboardAmount .amountList > div:nth-child(4)::after {
    width: 2px;
    /* height: 67px; */
    content: '';
    top: 13px;
    right: -4px;
    bottom: 0;
    position: absolute;
    margin: 0 auto;
    background-color: #d8d8d8;
  }

  .dashboardAmount .rightIcon img {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 37px;
    height: 37px;
    margin-top: 20px;
  }
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .dashboardAmount .amountList {
    padding: 0 !important;
  }

  .dashboardAmount .amountList > div {
    padding: 20px;
    flex: 0 0 33%;
    max-width: 33%;
  }

  .dashboardAmount .amountList > div:nth-child(1)::after,
  .dashboardAmount .amountList > div:nth-child(2)::after,
  .dashboardAmount .amountList > div:nth-child(4)::after {
    width: 2px;
    /* height: 85px; */
    content: '';
    top: 13px;
    right: -4px;
    bottom: 0;
    position: absolute;
    margin: 0 auto;
    background-color: #d8d8d8;
  }

  .dashboardAmount .rightIcon img {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 50px;
    height: 50px;
    margin-top: 20px;
  }
}

@media (min-width: 992px) and (max-width: 1199.98px) {
  .dashboardAmount .amountList {
    padding: 0 !important;
  }

  .dashboardAmount .amountList > div {
    padding: 13px 10px;
    flex: 0 0 25%;
    max-width: 25%;
  }

  .dashboardAmount .rightIcon img {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 45px;
    height: 45px;
    margin-top: 20px;
  }

  .dashboardAmount .amountList > div:nth-child(1)::after,
  .dashboardAmount .amountList > div:nth-child(2)::after,
  .dashboardAmount .amountList > div:nth-child(3)::after {
    width: 2px;
    content: '';
    top: 3px;
    right: 0;
    bottom: 0;
    position: absolute;
    margin: 0 auto;
    background-color: #d8d8d8;
  }
}

.dashboardAmount .amountList > div {
  position: relative;
}

@media (min-width: 768px) {
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
}

.custom-select {
  width: auto;
}
/* Dashboard Balance CSS ends here */

.btn-submit {
  background-color: #007bff !important;
  color: white !important;
  transition: background-color 0.3s ease;
  margin: 10px;
}

.btn-submit.btn-disabled,
.btn-submit:disabled {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
  border: none;
}

.dashoard {
  margin-top: 2px;
}

.hide-widget {
  position: absolute;
  right: 2%;
  bottom: 2%;
  z-index: 1;
}

.hide-widget button {
  color: white;
  background-color: #36f;
  border: 1px solid #36f;
  transition: all 0.3s ease;
  border-radius: 5px;
}

.hide-widget button:hover {
  color: #36f;
  background-color: white;
  border: 1px solid #36f;
  border-radius: 5px;
}

[cdkDropList] {
  display: flex;
  flex-wrap: wrap;
}

[cdkDrag] {
  transition: transform 0.25s ease;
  /* z-index: 1000; */
}

.drag-card {
  transition: transform 0.2s ease;
}

.stepTop {
  padding-top: 0% !important;
}

.form-popup .content {
  min-width: 200px;
}

.custom-select {
  width: 100%;
}

.customselect {
  width: 65%;
}

.chart canvas {
  display: block;
  padding: 10px;
  min-height: 340px;
  max-height: 340px;
}

.chart,
.performinAgentChart {
  position: relative;
  width: 100%;
  max-height: 380px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}

.chart-header {
  display: flex;
  justify-content: center;
  align-items: center;
}
.channel-title {
  font-weight: bold;
  font-size: 18px;
  margin: 0 20px;
}

.channel-name {
  font-weight: bold;
  font-size: 18px;
  margin: 0 20px;
  color: #6f95cd;
}
/* 
.partnerChart {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  height: 465px;
  overflow-y: auto;
}

.partnerChart .chart-row {
  flex: 0 0 calc(50% - 2rem);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.partnerChart .partnerChartCanvas {
  width: auto !important;
  height: auto !important;
  max-width: 300px;
  max-height: 300px;
}

.partnerChart .partnerChartCanvas1 {
  width: 600px;
  height: auto;
  max-width: 1000px;
  max-height: 1000px;
} */

.partnerChart {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 1rem; /* optional spacing */
}

.partnerChart .chart-row {
  flex: 0 0 calc(50% - 1rem); /* 2 charts per row */
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}

/* Container for all pie charts */

/* For multi-chart layout */
.channelChart {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.channelChart1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* Each row of up to 2 charts */
.chart-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: flex-start;
  width: 100%;
  margin-top: 1rem;
}

/* Wrapper for individual chart with legend */
.chart-with-legend {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 calc(50% - 2rem);
  margin-bottom: 2rem;
}

.chart-with-legend.single-chart {
  flex: 0 0 100%;
  max-width: 100%;
}

/* Doughnut canvas sizes */
.chart-with-legend canvas {
  width: 200px !important;
  height: 200px !important;
}
.chart-with-legend.single-chart canvas {
  width: 300px !important;
  height: 300px !important;
}

/* Legend styles */
.legend-box {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}
.legend-item {
  display: flex;
  align-items: center;
  gap: 5px;
}
.legend-square {
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

/* Chart title */
.chart-with-legend h4 {
  margin: 10px 0;
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/assets/theme/css/dashboard.css"],"names":[],"mappings":"AAAA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,uDAAuD;EACvD,aAAa;AACf;;AAEA;EACE;kBACgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,iCAAiC;EACjC,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;;EAEE,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,qBAAqB;EACvB;AACF;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF;AACA;EACE;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;EACZ;AACF;;AAEA;EAEE,YAAY;AACd;;AAEA,iCAAiC;;AAEjC,gCAAgC;AAChC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;EACjC,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;AAC7B;AACA,MAAM;;AAEN;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;;IAEE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,iCAAiC;IACjC,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;EAC5B;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA,gCAAgC;;AAEhC,iCAAiC;;AAEjC;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;EACvC,UAAU;AACZ;AACA,+BAA+B;;AAE/B,uDAAuD;;AAEvD;EACE;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;AACA;EACE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,UAAU;IACV,WAAW;IACX,mBAAmB;EACrB;AACF;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,6BAA6B;EAC/B;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;EACvD,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA,qDAAqD;;AAErD,sCAAsC;;AAEtC;;EAEE,uCAAuC;EACvC,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;;;;IAIE,UAAU;IACV,WAAW;IACX,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,cAAc;EAChB;;EAEA;;;IAGE,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,cAAc;EAChB;;EAEA;;;IAGE,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;;IAGE,UAAU;IACV,WAAW;IACX,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;IACd,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;AACb;AACA,oCAAoC;;AAEpC;EACE,oCAAoC;EACpC,uBAAuB;EACvB,sCAAsC;EACtC,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6BG;;AAEH;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,SAAS,EAAE,qBAAqB;AAClC;;AAEA;EACE,0BAA0B,EAAE,qBAAqB;EACjD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,iCAAiC;;AAEjC,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["*,\n::after,\n::before {\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Montserrat', Arial, Helvetica, sans-serif;\n  color: '#000';\n}\n\n.card {\n  /* max-height: 450px; \n  overflow: auto;*/\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff !important;\n  background-clip: border-box;\n  border: 1px solid #c8ced3;\n  margin-bottom: 0rem;\n  box-shadow: 0 1px 4px 0 #545a61ed;\n}\n.chart-card {\n  min-height: 450px;\n  max-height: 450px;\n}\n\n@media only screen and (max-width: 760px) {\n  .chart-card {\n    min-height: 530px;\n    max-height: 530px;\n    margin-bottom: 1rem;\n  }\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: 0.5rem;\n}\n\n.card .card-title {\n  position: relative;\n  color: black;\n  font-size: 18px !important;\n}\n\n.card,\n.floating-labels select.form-control > option {\n  background: #ffffff;\n  border-radius: 7px !important;\n}\n\n.card,\n.floating-labels select.form-control > option {\n  background: var(--foreground-secondary);\n  border-radius: 7px !important;\n}\n\n@media (min-width: 321px) and (max-width: 575.98px) {\n  .card-body .form-group {\n    margin: 0;\n  }\n}\n\n.h4,\nh4 {\n  font-size: 1.3125rem;\n}\n\n@media (min-width: 768px) and (max-width: 991.98px) {\n  .section h4.card-title {\n    font-size: 18px;\n  }\n}\n\n@media (min-width: 768px) {\n  .col-md-7 {\n    flex: 0 0 58.33333333%;\n    max-width: 96.333333%;\n  }\n}\n\n@media (min-width: 576px) {\n  .mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important;\n  }\n}\n\n@media (min-width: 321px) and (max-width: 575.98px) {\n  .section .row {\n    margin-bottom: 20px;\n  }\n}\n\n@media (min-width: 992px) {\n  .performance .col-xl-6 :nth-child(odd) {\n    padding-right: 0.65em;\n  }\n}\n\n@media (min-width: 1200px) {\n  .col-xl-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n}\n@media (min-width: 768px) {\n  .col-md-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n}\n\n@media (min-width: 992px) {\n  .hide-widget {\n    position: absolute;\n    right: 4%;\n    bottom: 2%;\n    z-index: 1;\n  }\n}\n\n.row.section div {\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n\n/* Header Icons CSS starts here */\n\n/* @media (min-width: 601px) { */\n.calenderIcons {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid rgb(4, 84, 170);\n  color: rgb(4, 84, 170);\n  width: 35px;\n  border-radius: 20px;\n  height: 35px;\n  margin-top: -8px !important;\n}\n/* } */\n\n.calenderIcons:hover {\n  color: #fff !important;\n  background: #36f !important;\n  border: 1px solid rgb(17, 42, 119) !important;\n}\n\n.calenderIcons:focus {\n  color: #fff !important;\n  background: #36f !important;\n  border: 1px solid rgb(17, 42, 119) !important;\n}\n\n.calenderIConCLicked {\n  cursor: pointer;\n  position: relative;\n  width: auto;\n}\n\n@media (min-width: 992px) {\n  .pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important;\n  }\n}\n\n@media (max-width: 600px) {\n  .calenderIcons {\n    border: 1px solid rgb(4, 84, 170);\n    color: rgb(4, 84, 170);\n    width: auto;\n  }\n  .card .card-title {\n    position: relative;\n    color: black;\n    font-size: 16px !important;\n  }\n}\n\n.button {\n  margin: 4px 2px;\n}\n\n/* Header Icons CSS ends here  */\n\n/* Dialog popup css starts here */\n\n.form-container {\n  /* max-width: auto; */\n  width: min-content;\n  padding: 10px;\n  background-color: white;\n}\n\n.form-popup {\n  display: none;\n  position: absolute;\n  top: 8%;\n  right: 6%;\n  border: 3px solid #f1f1f1;\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n  z-index: 9;\n}\n\n.form-popup1 {\n  display: none;\n  position: absolute;\n  margin: 15px;\n  top: 5%;\n  right: 6%;\n  border: 3px solid #f1f1f1;\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n  z-index: 9;\n}\n/* Dialog popup css ends here */\n\n/* Production Performance button list css starts here */\n\n@media (min-width: 576px) and (max-width: 767.98px) {\n  .floating-labels .row {\n    margin-left: -2px;\n    /* margin-right: -15px; */\n  }\n}\n\n@media (min-width: 601px) {\n  .floating-labels select.form-control > option {\n    font-size: 14px;\n    bottom: 25px !important;\n  }\n}\n\n.floating-labels select.form-control > option {\n  font-size: 14px;\n}\n\n.floating-labels .row {\n  margin-top: 10px;\n  margin-left: -15px;\n  margin-right: -15px;\n}\n.floating-labels select option {\n  width: 20em;\n}\n\n.floating-labels .form-group {\n  position: relative;\n  margin-right: -18px;\n}\n\n.performance {\n  z-index: 0;\n}\n@media (min-width: 1200px) {\n  .performance .card-body .form-group {\n    margin: 0;\n  }\n\n  .performance .card-body .form-group .form-control {\n    font-size: 14px;\n    padding: 0;\n    width: 85px;\n    margin: -11px 7px 0;\n  }\n}\n.floating-labels .form-control {\n  padding: 8px 10px 10px;\n  display: block;\n  border: none;\n  border-radius: 0;\n  border-bottom: 1.5px solid #707070;\n}\n\n.form-group {\n  margin-bottom: 1.25rem !important;\n}\n\n@media (min-width: 321px) and (max-width: 575.98px) {\n  .floating-labels select {\n    background-position-x: 96%;\n    background-position-y: 46%;\n    font-size: 10px;\n    margin-right: -5px !important;\n  }\n  .floating-labels .form-group {\n    position: relative;\n    margin-right: -32px;\n  }\n  .textLabel {\n    font-size: 8px;\n  }\n}\n\n.section .container {\n  max-width: 25%;\n}\n\n/* .section .active::after {\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-top: 13px solid #2f353a;\n  content: '';\n  position: absolute;\n  right: 0;\n  left: 0;\n  top: initial;\n  bottom: -13px;\n  margin: 0 auto;\n} */\n\n.section button {\n  border-color: #eaeaea;\n  border-width: 1px;\n}\n\n.section button {\n  border-color: var(--graph-btn-border);\n  color: black;\n}\n\n.section .btn-outline-dark {\n  border-radius: 6px;\n  font-family: 'Montserrat', Arial, Helvetica, sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  border: 2px solid #2f353a;\n  color: #2f353a;\n  background-color: #ffffff;\n  transition: all 0.3s ease-in-out;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.section .btn-outline-dark:hover {\n  color: #fff;\n  background-color: #2f353a;\n  border-color: #2f353a;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.btn-outline-dark:not(:disabled):not(.disabled).active,\n.btn-outline-dark:not(:disabled):not(.disabled):active,\n.show > .btn-outline-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #2f353a;\n  border-color: #2f353a;\n  box-shadow: inset 0 0 0 1px #1e2226;\n}\n\n.button {\n  margin: 4px 2px;\n}\n\n@media (min-width: 768px) {\n  .col-md-3 {\n    flex: 0 0 35%;\n    max-width: 40%;\n  }\n}\n\n/* Production Performance button list css ends here */\n\n/* Dashboard Balance CSS starts here */\n\n.dashboardAmount,\n.empty-data {\n  background: var(--foreground-secondary);\n  border-radius: 7px !important;\n  box-shadow: 0 1px 4px 0 #545a61ed;\n}\n\n.dashboardAmount .amountList {\n  margin: 10px auto;\n  width: 95%;\n  position: relative;\n  padding: 10px 20px;\n}\n\n@media (min-width: 1200px) {\n  .dashboardAmount .amountList > div:first-child {\n    padding-left: 0;\n  }\n\n  .dashboardAmount .amountList > div {\n    padding: 10px 15px;\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n\n  .dashboardAmount .rightIcon img {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 45px;\n    height: 45px;\n    margin-top: 0;\n  }\n\n  .dashboardAmount .amountList > div:nth-child(1)::after,\n  .dashboardAmount .amountList > div:nth-child(2)::after,\n  .dashboardAmount .amountList > div:nth-child(3)::after,\n  .dashboardAmount .amountList > div:nth-child(4)::after {\n    width: 2px;\n    content: '';\n    top: 3px;\n    right: 0;\n    bottom: 0;\n    position: absolute;\n    margin: 0 auto;\n    background-color: #d8d8d8;\n  }\n}\n\n@media (min-width: 321px) and (max-width: 575.98px) {\n  .dashboardAmount .amountList {\n    padding: 0 !important;\n  }\n\n  .dashboardAmount .amountList > div {\n    padding: 20px;\n    flex: 0 0 90%;\n    max-width: 90%;\n    margin: 0 auto;\n  }\n\n  .dashboardAmount .rightIcon img {\n    position: absolute;\n    bottom: 14px;\n    right: 0;\n    width: 45px;\n    height: 45px;\n    margin-top: 20px;\n  }\n}\n\n@media (min-width: 576px) and (max-width: 767.98px) {\n  .dashboardAmount .amountList {\n    padding: 0 !important;\n  }\n\n  .dashboardAmount .amountList > div {\n    padding: 10px;\n    flex: 0 0 33%;\n    max-width: 33%;\n  }\n\n  .dashboardAmount .amountList > div:nth-child(1)::after,\n  .dashboardAmount .amountList > div:nth-child(2)::after,\n  .dashboardAmount .amountList > div:nth-child(4)::after {\n    width: 2px;\n    /* height: 67px; */\n    content: '';\n    top: 13px;\n    right: -4px;\n    bottom: 0;\n    position: absolute;\n    margin: 0 auto;\n    background-color: #d8d8d8;\n  }\n\n  .dashboardAmount .rightIcon img {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 37px;\n    height: 37px;\n    margin-top: 20px;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 991.98px) {\n  .dashboardAmount .amountList {\n    padding: 0 !important;\n  }\n\n  .dashboardAmount .amountList > div {\n    padding: 20px;\n    flex: 0 0 33%;\n    max-width: 33%;\n  }\n\n  .dashboardAmount .amountList > div:nth-child(1)::after,\n  .dashboardAmount .amountList > div:nth-child(2)::after,\n  .dashboardAmount .amountList > div:nth-child(4)::after {\n    width: 2px;\n    /* height: 85px; */\n    content: '';\n    top: 13px;\n    right: -4px;\n    bottom: 0;\n    position: absolute;\n    margin: 0 auto;\n    background-color: #d8d8d8;\n  }\n\n  .dashboardAmount .rightIcon img {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 50px;\n    height: 50px;\n    margin-top: 20px;\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1199.98px) {\n  .dashboardAmount .amountList {\n    padding: 0 !important;\n  }\n\n  .dashboardAmount .amountList > div {\n    padding: 13px 10px;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .dashboardAmount .rightIcon img {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 45px;\n    height: 45px;\n    margin-top: 20px;\n  }\n\n  .dashboardAmount .amountList > div:nth-child(1)::after,\n  .dashboardAmount .amountList > div:nth-child(2)::after,\n  .dashboardAmount .amountList > div:nth-child(3)::after {\n    width: 2px;\n    content: '';\n    top: 3px;\n    right: 0;\n    bottom: 0;\n    position: absolute;\n    margin: 0 auto;\n    background-color: #d8d8d8;\n  }\n}\n\n.dashboardAmount .amountList > div {\n  position: relative;\n}\n\n@media (min-width: 768px) {\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n}\n\n.custom-select {\n  width: auto;\n}\n/* Dashboard Balance CSS ends here */\n\n.btn-submit {\n  background-color: #007bff !important;\n  color: white !important;\n  transition: background-color 0.3s ease;\n  margin: 10px;\n}\n\n.btn-submit.btn-disabled,\n.btn-submit:disabled {\n  background-color: #cccccc;\n  color: #666666;\n  cursor: not-allowed;\n  border: none;\n}\n\n.dashoard {\n  margin-top: 2px;\n}\n\n.hide-widget {\n  position: absolute;\n  right: 2%;\n  bottom: 2%;\n  z-index: 1;\n}\n\n.hide-widget button {\n  color: white;\n  background-color: #36f;\n  border: 1px solid #36f;\n  transition: all 0.3s ease;\n  border-radius: 5px;\n}\n\n.hide-widget button:hover {\n  color: #36f;\n  background-color: white;\n  border: 1px solid #36f;\n  border-radius: 5px;\n}\n\n[cdkDropList] {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n[cdkDrag] {\n  transition: transform 0.25s ease;\n  /* z-index: 1000; */\n}\n\n.drag-card {\n  transition: transform 0.2s ease;\n}\n\n.stepTop {\n  padding-top: 0% !important;\n}\n\n.form-popup .content {\n  min-width: 200px;\n}\n\n.custom-select {\n  width: 100%;\n}\n\n.customselect {\n  width: 65%;\n}\n\n.chart canvas {\n  display: block;\n  padding: 10px;\n  min-height: 340px;\n  max-height: 340px;\n}\n\n.chart,\n.performinAgentChart {\n  position: relative;\n  width: 100%;\n  max-height: 380px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow-y: auto;\n}\n\n.chart-header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.channel-title {\n  font-weight: bold;\n  font-size: 18px;\n  margin: 0 20px;\n}\n\n.channel-name {\n  font-weight: bold;\n  font-size: 18px;\n  margin: 0 20px;\n  color: #6f95cd;\n}\n/* \n.partnerChart {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  height: 465px;\n  overflow-y: auto;\n}\n\n.partnerChart .chart-row {\n  flex: 0 0 calc(50% - 2rem);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.partnerChart .partnerChartCanvas {\n  width: auto !important;\n  height: auto !important;\n  max-width: 300px;\n  max-height: 300px;\n}\n\n.partnerChart .partnerChartCanvas1 {\n  width: 600px;\n  height: auto;\n  max-width: 1000px;\n  max-height: 1000px;\n} */\n\n.partnerChart {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 1rem; /* optional spacing */\n}\n\n.partnerChart .chart-row {\n  flex: 0 0 calc(50% - 1rem); /* 2 charts per row */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n/* Container for all pie charts */\n\n/* For multi-chart layout */\n.channelChart {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.channelChart1 {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Each row of up to 2 charts */\n.chart-row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  align-items: flex-start;\n  width: 100%;\n  margin-top: 1rem;\n}\n\n/* Wrapper for individual chart with legend */\n.chart-with-legend {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 0 0 calc(50% - 2rem);\n  margin-bottom: 2rem;\n}\n\n.chart-with-legend.single-chart {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n/* Doughnut canvas sizes */\n.chart-with-legend canvas {\n  width: 200px !important;\n  height: 200px !important;\n}\n.chart-with-legend.single-chart canvas {\n  width: 300px !important;\n  height: 300px !important;\n}\n\n/* Legend styles */\n.legend-box {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 10px;\n}\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.legend-square {\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n}\n\n/* Chart title */\n.chart-with-legend h4 {\n  margin: 10px 0;\n  font-size: 1rem;\n  font-weight: 500;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
